/**
 * Checks if a given hostname is considered an internal host.
 * Internal hosts are:
 * - localhost
 * - Any domain that starts with "app" and ends with ".logyx.it" (e.g., app.logyx.it, app-v2.logyx.it, app-staging.logyx.it)
 *
 * @param hostname - The hostname to check
 * @returns true if the hostname is an internal host, false otherwise
 */
export const isInternalHost = (hostname: string): boolean => {
  // Match localhost or any hostname that starts with "app" and ends with ".logyx.it"
  const internalHostRegex = /^(localhost|app.*\.logyx\.it)$/;
  return internalHostRegex.test(hostname);
};

/**
 * Checks if a given hostname should be considered an external host.
 * An external host is any hostname that is NOT an internal host.
 *
 * @param hostname - The hostname to check
 * @returns true if the hostname is an external host, false otherwise
 */
export const isExternalHost = (hostname: string): boolean => {
  return !isInternalHost(hostname);
};
